import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class ActionSheetService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService) { }

  getId = (): string => 'actionSheet';

  getTitle = (): string => 'Action Sheet';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'action-sheet/0', 'title': 'Basic', 'theme': 'layout1' },
      { 'url': 'action-sheet/1', 'title': 'News', 'theme': 'layout2' },
      { 'url': 'action-sheet/2', 'title': 'With Cards', 'theme': 'layout3' }
    ];
  }

  getDataForTheme = (menuItem: any): any => {
    return this[
      'getDataFor' +
      menuItem.theme.charAt(0).toUpperCase() +
      menuItem.theme.slice(1)
    ]();
  }

  //* Data Set for page 1
  getDataForLayout1 = (): any => {
    return {
      'toolbarTitle': 'Basic',
      'headerImage': 'assets/imgs/background/6.jpg',
      'shareIcon': "ellipsis-horizontal",
      'title': 'The Peninsula Chicago',
      'description': "Hoc est, visu nova thriller, posuit orbem in fimbriis modern arte, quae est tenebrosa, haunting, torta - vertit se et in suo modo. Non quod objective, et arte discipulus apud Notingham, nuper Jack quae ducitur 'diluvium, ' frigus, saeva enfant inexpugnabiles omnes modern art. Et vadit ad deversorium cubiculum vult bibere et cetera id exuendum statum tunc illa e somno evigilans in lecto suo.",
      'price': '$ 750',
      'images': 'Images',
      'reviews': 'Reviews',
      'seeAll': 'See All',
      'actionSheet': {
        'buttons': [
          {
            'text': 'Add to Cart',
            'role': 'destructive'
          },
          {
            'text': 'Add to Favorites'
          },
          {
            'text': 'Read more info'
          },
          {
            'text': 'Delete Item'
          },
          {
            'text': 'Cancel',
            'role': 'cancel'
          }
        ]
      },
      'image': [
        {
          'id': 1,
          'image': 'assets/imgs/background/8.jpg',
        },
        {
          'id': 2,
          'image': 'assets/imgs/background/9.jpg',
        },
        {
          'id': 3,
          'image': 'assets/imgs/background/6.jpg',
        },
        {
          'id': 4,
          'image': 'assets/imgs/background/5.jpg',
        },
        {
          'id': 5,
          'image': 'assets/imgs/background/7.jpg',
        },
      ],

      'items': [
        {
          'id': 1,
          'image': 'assets/imgs/avatar/20.jpg',
          'title': 'Carole Marvin',
          'time': '18 August',
          'description': `I\’ve learned that people will forget what you said,
                                 people will forget what you did, but people will never forget how you made them feel`,
        },
        {
          'id': 2,
          'image': 'assets/imgs/avatar/21.jpg',
          'title': 'Doriana Feeney',
          'time': '19 August',
          'description': `I\’ve learned that people will forget what you said,
                                 people will forget what you did, but people will never forget how you made them feel`,
        },
        {
          'id': 3,
          'image': 'assets/imgs/avatar/22.jpg',
          'title': 'Nia Gutkowski',
          'time': '20 August',
          'description': 'Life is what happens to you while you’re busy making other plans',
        }
      ]
    }
  };

  //* Data Set for page 2
  getDataForLayout2 = (): any => {
    return {
      'toolbarTitle': 'News',
      'headerImage': 'assets/imgs/background/7.jpg',
      'title': 'Park Hyatt Vienna',
      'category': 'Rooms',
      'shareIcon': "ellipsis-horizontal",
      'button': 'Book Now',
      'price': '$ 100',
      'priceTitle': 'per night',
      'image1': 'assets/imgs/background/8.jpg',
      'image2': 'assets/imgs/background/5.jpg',
      'image3': 'assets/imgs/background/9.jpg',
      'description1': "Hoc est, visu nova thriller, posuit orbem in fimbriis modern arte, quae est tenebrosa, haunting, torta - vertit se et in suo modo. Non quod objective, et arte discipulus apud Notingham, nuper Jack quae ducitur 'diluvium, ' frigus, saeva enfant inexpugnabiles omnes modern art. Et vadit ad deversorium cubiculum vult bibere et cetera id exuendum statum tunc illa e somno evigilans in lecto suo.",
      'description2': "Hoc est, visu nova thriller, posuit orbem in fimbriis modern arte, quae est tenebrosa, haunting, torta - vertit se et in suo modo. Non quod objective, et arte discipulus apud Notingham, nuper Jack quae ducitur 'diluvium, ' frigus, saeva enfant inexpugnabiles omnes modern art. Et vadit ad deversorium cubiculum vult bibere et cetera id exuendum statum tunc illa e somno evigilans in lecto suo.",
      'actionSheet': {
        'buttons': [
          {
            'text': 'Add to Cart',
            'role': 'destructive'
          },
          {
            'text': 'Add to Favorites'
          },
          {
            'text': 'Read more info'
          },
          {
            'text': 'Delete Item'
          },
          {
            'text': 'Cancel',
            'role': 'cancel'
          }
        ]
      },
    };
  };

  //* Data Set for page 3
  getDataForLayout3 = (): any => {
    return {
      'toolbarTitle': 'With Cards',
      'shareIcon': "ellipsis-horizontal",
      'actionSheet': {
        'title': 'Choose what to do with this card?',
        'buttons': [
          {
            'text': 'Read more',
            'role': 'destructive'
          },
          {
            'text': 'Add to Favorites'
          },
          {
            'text': 'Delete Card'
          },
          {
            'text': 'Disable Card'
          },
          {
            'text': 'Cancel',
            'role': 'cancel'
          }
        ]
      },
      'items': [
        {
          'id': 1,
          'avatarTitle': 'Jason Graham',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/20.jpg',
          'title': '45 Park Lane',
          'subtitle': '2 beds',
          'price': '$ 20 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/8.jpg',
        },
        {
          'id': 2,
          'avatarTitle': 'Jason Graham',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/23.jpg',
          'title': 'Encore Macau',
          'subtitle': '3 beds',
          'price': '$ 700 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/9.jpg',
        },
        {
          'id': 3,
          'avatarTitle': 'Jason Graham',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/21.jpg',
          'title': 'Bulgari Hotel London',
          'subtitle': '2 beds',
          'price': '$ 300 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/6.jpg',
        },
        {
          'id': 4,
          'avatarTitle': 'Jason Graham',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/22.jpg',
          'title': 'Belmond El Encanto',
          'subtitle': '1 beds',
          'price': '$ 500 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/5.jpg',
        },
        {
          'id': 5,
          'avatarTitle': 'Jason Graham',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/24.jpg',
          'title': 'The Alpina Gstaad',
          'subtitle': '3 beds',
          'price': '$ 400 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/7.jpg',
        },
      ]
    };
  }

  load(item: any): Observable<any> {
    const that = this;
    that.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('actionSheet/' + item.theme)
          .valueChanges()
          .subscribe(snapshot => {
            that.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            that.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        that.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
